export default __webpack_public_path__ + "static/media/undo-modal-icon.6d0f5f90.svg";